import { useSuspenseQueries } from '@tanstack/react-query';

import type * as api from '@gitbook/api-client';

import { apiQuery } from '../../../state';

/** Load complete current revisions for the spaces shown in a content picker. */
export function useSpaceRevisions(spaces: api.Space[]): ReadonlyMap<string, api.Revision> {
    const uniqueSpaces = Array.from(new Map(spaces.map((space) => [space.id, space])).values());
    const results = useSuspenseQueries({
        queries: uniqueSpaces.map((space) =>
            apiQuery('getRevisionById', {
                spaceId: space.id,
                revisionId: space.revision,
                metadata: false,
                computed: true,
            })
        ),
    });

    return new Map(
        results.flatMap((result, index) => {
            return result.data ? [[uniqueSpaces[index].id, result.data] as const] : [];
        })
    );
}
